import { useMemo } from 'react'
import { indexItems, matchItems } from '../lib/search'
import { userLocale } from '../lib/locale'
import { knownName, type KnownName } from '../lib/catalog'

// The name fields' suggestions (components/choices/NameField, the recipe
// editor's ingredient rows): quick add's ranking over the household's names.

const SUGGESTIONS = 5

/**
 * The household's names close to `value`, as quick add ranks them, and the one
 * it surely means (lib/catalog.ts knownName) when that is spelled differently —
 * "fast potatis" while the list says "Potatis fast". Neither is the name as typed.
 */
export function useNameSuggestions(value: string, known: KnownName[]): { suggestions: KnownName[]; sure: string | null } {
  const index = useMemo(() => indexItems(known), [known])
  return useMemo(() => {
    const typed = value.trim().toLocaleLowerCase()
    if (!typed) return { suggestions: [], sure: null }
    const suggestions = matchItems(index, value, userLocale(), SUGGESTIONS + 1)
      .filter(k => k.name.toLocaleLowerCase() !== typed)
      .slice(0, SUGGESTIONS)
    const match = knownName(value, index)
    return { suggestions, sure: match && match.toLocaleLowerCase() !== typed ? match : null }
  }, [index, value])
}
